<template>
  <div
    :class="[
      'navbar p-0',
      {
        'close-sidebar': currentUrl.includes(urls.services),
        'lang-en': $i18n.locale === 'en',
      },
    ]"
  >
    <div
      class="container-fluid p-0 position-relative d-flex align-items-center justify-content-between"
    >
      <div class="d-flex">
        <div
          class="menu-toggle-btn navbar-item d-flex align-items-center"
          @click="toggleSidebar"
          data-gtm-name="main_main_menu_mark"
        >
          <i class="fa fa-bars font-6"></i>
        </div>
      </div>
      <div class="d-flex">
        <div class="dropdown navbar-item d-flex align-items-center">
          <button
            class="btn dropdown-toggle d-flex border-0 py-0 px-3"
            id="services_dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-gtm-name="main_services"
          >
            <i class="fas fa-th mx-2 font-5"></i>
            <span class="d-none d-sm-block" style="font-weight: 700">{{
              $t("khadamat")
            }}</span>
          </button>
          <div
            class="dropdown-menu py-3"
            style="min-width: 17rem"
            aria-labelledby="services_dropdown"
          >
            <div class="row mx-0">
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=najva`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="najva"
                >
                  <img class="service-item_img" :src="urls.najvaLogo" />
                  <div class="service-item_title">
                    {{ $t("najva_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pl-3 pr-2 pb-3">
                <a
                  :href="`${urls.services}?plt=yektanet`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="yektanet"
                >
                  <img class="service-item_img" :src="urls.yektanetLogo" />
                  <div class="service-item_title">
                    {{ $t("yektanet_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=triboon`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="triboon"
                >
                  <img class="service-item_img" :src="urls.triboonLogo" />
                  <div class="service-item_title">
                    {{ $t("triboon_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=jaryan`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="jaryan"
                >
                  <img
                    class="service-item_img"
                    style="width: 75px"
                    :src="urls.jaryanLogo"
                  />
                  <div class="service-item_title">
                    {{ $t("jaryan_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=sanjab`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="sanjab"
                >
                  <img class="service-item_img" :src="urls.sanjabLogo" />
                  <div class="service-item_title">
                    {{ $t("sanjab_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=adivery`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="adivery"
                >
                  <img class="service-item_img" :src="urls.adiveryLogo" />
                  <div class="service-item_title">
                    {{ $t("adivery_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=chavosh`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="chavosh"
                >
                  <img class="service-item_img" :src="urls.chavoshLogo" />
                  <div class="service-item_title">
                    {{ $t("chavosh_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=pajva`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="pajva"
                >
                  <img class="service-item_img" :src="urls.pajvaLogo" />
                  <div class="service-item_title">
                    {{ $t("pajva_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3">
                <a
                  :href="`${urls.services}?plt=fahva`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="fahva"
                >
                  <img class="service-item_img" :src="urls.fahvaLogo" />
                  <div class="service-item_title">
                    {{ $t("fahva_name") }}
                  </div>
                </a>
              </div>
              <div class="col-6 pr-3 pl-2 pb-3 d-none">
                <a
                  :href="`${urls.services}?plt=bordboard`"
                  class="service-item rounded-0 border-0 p-0 btn btn-default"
                  data-gtm-name="main_services_select"
                  data-gtm-value-one="bordboard"
                >
                  <img class="service-item_img" :src="urls.bordboardLogo" />
                  <div class="service-item_title">
                    {{ $t("bordboard_name") }}
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown navbar-item d-flex align-items-center">
          <button
            class="
            btn
            dropdown-toggle
            d-flex
            align-items-center
            h-100
            border-0
            py-0
            px-3
          "
            id="account_dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-gtm-name="main_account_name"
          >
            <div
              class="avatar-small rounded-circle overflow-hidden mx-0 mx-sm-1"
            >
              <img :src="profileImage" alt="user profile image" />
            </div>
            <div class="info rounded-circle d-none d-sm-block">
              <div
                class="
                text-center
                user_email_navbar
                ellipsis_long_text
                mx-auto
                d-block
                ltr
              "
              >
                <span>{{ fullName }}</span>
              </div>
            </div>
          </button>
          <div
            class="dropdown-menu"
            style="min-width: 15rem"
            aria-labelledby="account_dropdown"
          >
            <div class="mb-2 mt-3">
              <div class="avatar-big rounded-circle overflow-hidden mx-auto">
                <img :src="profileImage" alt="user profile image" />
              </div>
            </div>
            <div class="text-center">
              <span>{{ fullName }}</span>
            </div>
            <div class="text-center">
              <a
                :href="urls.accountEmail"
                class="
                ellipsis_long_text
                px-4
                mx-auto
                my-2
                d-block
                ltr
                text-secondary
              "
                style="max-width: 300px"
                data-gtm-name="main_account_name_email"
              >
                <span v-if="email">
                  {{ email }}
                </span>
                <span v-else class="d-block" style="direction: rtl">
                  ایمیل وارد نشده ‌است.
                </span>
              </a>
              <a
                :href="urls.phoneManagementView"
                :class="[
                  'ellipsis_long_text px-4 mx-auto my-2 d-block ltr link-secondary',
                  { fanum: $i18n.locale !== 'en' },
                ]"
                data-gtm-name="main_account_name_phone"
              >
                <span
                  v-if="mobile"
                  style="max-width: 300px; letter-spacing: 2px; font-size: 16px"
                >
                  {{ mobile }}
                </span>
                <span v-else class="d-block" style="direction: rtl">
                  شماره موبایل وارد نشده ‌است.
                </span>
              </a>
            </div>
            <div class="footer mt-4 d-flex justify-content-center">
              <a
                :href="urls.accountLogout"
                class="btn btn-outline-secondary rounded-0"
                data-gtm-name="main_account_name_exit"
              >
                {{ $t("exit") }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _sidebar, changeLang } from "~/utils";

export default {
  data: () => ({
    ...sData,
  }),
  mounted() {
    const page_title = (document.querySelector("title").innerText || "").trim();
    window.dataLayer.push({
      event: "virtual-page-view",
      user_id: this.userId,
      user_name: this.username,
      is_hijacked: this.isHijack,
      page_title,
    });
  },
  methods: {
    toggleSidebar() {
      _sidebar("toggle");

      bootstrap.Popover.getOrCreateInstance(
        document.querySelector("#openCode")
      ).hide();
      bootstrap.Popover.getOrCreateInstance(
        document.querySelector("#resend")
      ).hide();
      // $("#openCode").popover("hide");
      // $("#resend").popover("hide");
    },
    changeLang,
  },
};
</script>

<style lang="scss">
.navbar .dropdown-toggle::after {
  display: none;
}
.navbar {
  position: fixed;
  left: 0;
  top: 0;
  right: 230px;
  border-width: 1px !important;
  background-color: #fff;
  z-index: 1;
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  &.lang-en {
    right: 0;
    left: 230px;

    .navbar-item {
      border-right: unset;
      border-left: 2px solid #eaeaea;
    }

    .dropdown-menu {
      right: 0;
      left: auto;
    }
  }

  .navbar-item {
    height: 56px;
    padding: 0;
    border-right: 2px solid #eaeaea;

    &:hover {
      background-color: #edf7ff;
    }
  }

  & .dropdown-menu {
    margin-top: 0;
    border-radius: unset;
    left: 0;
    right: auto;
    padding: 0;
  }

  & .footer {
    border-top: 2px solid #eaeaea;
    padding: 10px;
    direction: ltr;
  }

  & .services_icon {
    width: 24px;
  }

  & .service-item {
    width: 100%;
    padding-top: 10px !important;
    padding-bottom: 10px !important;

    .service-item_img {
      display: block;
      height: 50px;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 10px;
    }
  }

  & .avatar-small {
    width: 35px;
    height: 35px;
  }

  & .avatar-big {
    width: 65px;
    height: 65px;
  }

  & .avatar-small img,
  & .avatar-big img {
    width: 100%;
    height: 100%;
  }

  & .user_email_navbar {
    font-weight: 700;
    max-width: 250px;
  }
}
@media screen and (max-width: 767) {
  .navbar {
    z-index: 5;
    right: 0;
  }
  .navbar.lang-en {
    z-index: 5;
    right: unset;
    left: 0;
  }
}
</style>
